import React from 'react'
import './CheckCashingView.scss'

import {
  Header,
  Button
} from 'semantic-ui-react'

import {getLanguageScope} from '../../../../helpers'
const _i18n = getLanguageScope('check_cashing_review');

class CheckReview extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {cancelTransaction, approveTransaction} = this.props;

    return (
        <div>
          <Header size='medium'>{_i18n('title')}</Header>
          <Button content={_i18n('cancel_transaction')} onClick={cancelTransaction} negative icon='close' labelPosition='left' />
          <Button content={_i18n('approve_transaction')} onClick={approveTransaction} positive icon='check' labelPosition='right' />
        </div>
    )
  }

}

export default CheckReview;


// WEBPACK FOOTER //
// ./src/components/Applications/CheckCashing/components/CheckReviewView.js